import apiClient from './api';
import API_ENDPOINTS from './endpoints';
// Obtener políticas de una ubicación
export const getLocationPolicies = async (locationId) => {
    try {
        const response = await apiClient.get(API_ENDPOINTS.LOCATION_POLICIES.BY_LOCATION(locationId));
        // Si success es false o data es null, no hay políticas
        if (!response || !response.success || !response.data) {
            return null;
        }
        return response.data;
    }
    catch (error) {
        console.error('Error fetching location policies:', error);
        return null;
    }
};
